// The Zones tab: every zone with its size, street progress and who has it.
import { useState } from 'react';
import { Button, Checkbox, Input, Pill } from '../lib/ui';
import { formatDay } from '../lib/trade';
import { zoneState, areaKm2, formatCount } from '../lib/leaflets';
import { byId } from './LeafletsCommon';

export default function LeafletsZonesList({ data, today, actions }) {
  const [q, setQ] = useState('');
  const [archived, setArchived] = useState(false);
  const people = byId(data.distributors);
  const term = q.trim().toLowerCase();
  const zones = data.zones
    .filter(z => archived || !z.archived)
    .filter(z => !term || [z.name, z.area, ...(z.streets || [])].some(v => (v || '').toLowerCase().includes(term)))
    .sort((a, b) => (a.area || '').localeCompare(b.area || '') || a.name.localeCompare(b.name));

  if (!data.zones.length) {
    return (
      <div className="trade-empty">
        <strong>No zones yet</strong>
        A zone is an area of streets drawn on the map. Draw one for each bundle of leaflets you'd hand out.
        <div style={{ marginTop: 12 }}><Button variant="primary" onClick={() => actions.editZone(null)}>+ New zone</Button></div>
      </div>
    );
  }

  return (
    <>
      <div className="trade-toolbar">
        <Input placeholder="Search zones, areas or streets…" value={q} onChange={e => setQ(e.target.value)} />
        <Checkbox checked={archived} onChange={e => setArchived(e.target.checked)} label="Show archived" style={{ fontSize: 13 }} />
      </div>
      <div className="ui-card" style={{ padding: 0, overflowX: 'auto' }}>
        <table className="trade-table">
          <thead>
            <tr><th>Zone</th><th className="num">Homes</th><th className="num">Streets done</th><th className="num">Size</th><th>Now</th><th>Last delivered</th><th /></tr>
          </thead>
          <tbody>
            {zones.map(zone => {
              const st = zoneState(zone, data.jobs, today);
              const done = (zone.streetsDone || []).filter(s => zone.streets.includes(s.name)).length;
              const term2 = term && (zone.streets || []).find(s => s.toLowerCase().includes(term));
              return (
                <tr key={zone._id} onClick={() => actions.editZone(zone)}>
                  <td>
                    <b>{zone.name}</b>
                    <span className="sub">{[zone.area, term2 && `has ${term2}`].filter(Boolean).join(' · ')}</span>
                  </td>
                  <td className="num">{zone.homes ? `~${formatCount(zone.homes)}` : ''}</td>
                  <td className="num">{zone.streets.length ? `${done} of ${zone.streets.length}` : ''}</td>
                  <td className="num">{areaKm2(zone.polygon).toFixed(2)} km²</td>
                  <td>
                    {zone.archived ? <Pill tone="warn">Archived</Pill>
                      : st.state === 'assigned' ? <Pill tone="blue">With {st.active.map(j => people[j.distributor]?.name.split(' ')[0]).join(' & ')}</Pill>
                        : st.state === 'covered' ? <Pill tone="ok">Done lately</Pill>
                          : <Pill>Free</Pill>}
                  </td>
                  <td>{st.last ? formatDay(st.last) : <span className="lf-muted">Never</span>}</td>
                  <td className="num" onClick={e => e.stopPropagation()}>
                    <div className="lf-row" style={{ justifyContent: 'flex-end', flexWrap: 'nowrap' }}>
                      <Button size="sm" onClick={() => actions.print({ zone, job: st.active[0] || null })}>Print</Button>
                      {!zone.archived && <Button size="sm" variant="primary" onClick={() => actions.assign({ zone: zone._id })}>Give out</Button>}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </>
  );
}
